/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { OtpForbiddenCode } from "./OtpForbiddenCode";
import { OtpStatus } from "./OtpStatus";
import * as t from "io-ts";

// required attributes
const OtpForbiddenR = t.interface({});

// optional attributes
const OtpForbiddenO = t.partial({
  otpForbiddenCode: OtpForbiddenCode,

  otpStatus: OtpStatus,

  remainingAttempts: t.Integer
});

export const OtpForbidden = t.intersection(
  [OtpForbiddenR, OtpForbiddenO],
  "OtpForbidden"
);

export type OtpForbidden = t.TypeOf<typeof OtpForbidden>;
